if (!customElements.get('rezica-floral-addons')) {
  customElements.define('rezica-floral-addons', class extends HTMLElement {
    connectedCallback() {
      if (this.abort) return;
      this.form = document.getElementById(this.dataset.form);
      if (!this.form) return;
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      this.prices = JSON.parse(this.querySelector('[data-variant-prices]').textContent);
      this.money = new Intl.NumberFormat(this.dataset.locale || 'en-IN', { style: 'currency', currency: this.dataset.currency, maximumFractionDigits: 2 });
      this.addEventListener('change', () => this.updateTotal(), options);
      this.form.addEventListener('change', () => this.updateTotal(), options);
      this.form.addEventListener('input', () => this.updateTotal(), options);
      const quantityInput = this.form.elements.namedItem('quantity');
      quantityInput?.addEventListener('input', () => this.updateTotal(), options);
      quantityInput?.addEventListener('change', () => this.updateTotal(), options);
      this.form.addEventListener('variant:change', () => this.updateTotal(), options);
      this.form.addEventListener('formdata', event => this.addItems(event.formData), options);
      const stickyForm = document.getElementById(this.dataset.stickyForm);
      stickyForm?.addEventListener('formdata', event => this.addItems(event.formData), options);
      this.updateTotal();
    }
    disconnectedCallback() {
      this.abort?.abort();
      this.abort = null;
    }
    selected() {
      return [...this.querySelectorAll('[data-addon-id]:checked:not(:disabled)')];
    }
    quantity() {
      return Math.max(1, Number(this.form.elements.namedItem('quantity')?.value || 1));
    }
    updateTotal() {
      const price = Number(this.prices[this.form.elements.namedItem('id')?.value] || 0);
      const extras = this.selected().reduce((sum, input) => sum + Number(input.dataset.addonPrice), 0);
      this.querySelector('[data-addon-total]').textContent = this.money.format(extras * this.quantity() / 100);
      this.querySelector('[data-product-total]').textContent = this.money.format((price + extras) * this.quantity() / 100);
    }
    addItems(data) {
      const selected = this.selected();
      const parentId = data.get('id');
      if (!selected.length || !parentId || data.has('items[0][id]')) return;
      const quantity = data.get('quantity') || String(this.quantity());
      const group = crypto.randomUUID();
      for (const [key, value] of [...data.entries()]) {
        if (key === 'id' || key === 'quantity' || key === 'selling_plan' || key.startsWith('properties[')) {
          data.delete(key);
          const target = key.startsWith('properties[') ? 'items[0][' + key.replace('properties[', 'properties][') : 'items[0][' + key + ']';
          data.append(target, value);
        }
      }
      data.set('items[0][id]', parentId);
      data.set('items[0][quantity]', quantity);
      data.set('items[0][properties][_PlatterBundle]', group);
      data.set('items[0][properties][' + this.dataset.propertyLabel + ']', selected.map(input => input.dataset.addonTitle).join(', '));
      selected.forEach((input, index) => {
        const prefix = 'items[' + (index + 1) + ']';
        data.set(prefix + '[id]', input.dataset.addonId);
        data.set(prefix + '[quantity]', quantity);
        data.set(prefix + '[parent_id]', parentId);
        data.set(prefix + '[properties][_PlatterBundle]', group);
        data.set(prefix + '[properties][For platter]', this.dataset.productTitle);
      });
    }
  });
}
